
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faCalculator as fasCalculator,
    } from '@fortawesome/pro-solid-svg-icons/faCalculator';

    import {
        faArrowAltUp as fasArrowAltUp,
    } from '@fortawesome/pro-solid-svg-icons';

    export default {
        name: 'JobCardAvg',

        components: {
            FontAwesomeIcon,
        },

        props: {
            isPayEstimated: {
                type: Boolean,
                default: false,
            },

            isPayAboveAvg: {
                type: Boolean,
                default: false,
            },

            showFullLabel: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                icons: {
                    fasCalculator,
                    fasArrowAltUp,
                },
            };
        },

        computed: {
            classList() {
                return [
                    'job-card-avg',
                    this.getVariantClass,
                ];
            },

            label() {
                if (this.isPayEstimated) {
                    return `Estimated ${this.showFullLabel ? 'pay' : ''}`;
                }

                if (this.isPayAboveAvg) {
                    return 'Above avg.';
                }

                return 'Base pay';
            },

            getVariantClass() {
                if (this.isPayEstimated) {
                    return 'is-pay-estimated text-body-4 text-dark-500';
                }

                if (this.isPayAboveAvg) {
                    return 'is-pay-above-avg text-title-4 text-primary-500';
                }

                return '';
            },
        },

        methods: {},
    };
